import { get } from 'lodash'
import * as React from 'react'

import { BaseVideoPlayer, PlayState } from '@envato/react-video'
import Magnifier from './magnifier'

const MagnifierConfigurator = ({
  item,
  videoMuted,
  muteVideo
}: {
  item: any
  videoMuted?: boolean
  muteVideo?: () => void
}) => {
  const previews = item.previews

  const getMagnifier = () => {
    if (get(previews, 'icon_with_square_preview.square_url')) {
      return (
        <Magnifier item={item} width={300} height={300}>
          <img src={previews.icon_with_square_preview.square_url} />
        </Magnifier>
      )
    }

    if (get(previews, 'icon_with_thumbnail_preview.thumbnail_url')) {
      const width = previews.icon_with_thumbnail_preview.thumbnail_width || 300
      const height =
        previews.icon_with_thumbnail_preview.thumbnail_height || 300
      return (
        <Magnifier item={item} width={width} height={height}>
          <img src={previews.icon_with_thumbnail_preview.thumbnail_url} />
        </Magnifier>
      )
    }

    if (get(previews, 'icon_with_video_preview.video_url')) {
      return (
        <Magnifier item={item} width={477} height={264}>
          <BaseVideoPlayer
            playState={PlayState.PLAY}
            muteVideo={muteVideo}
            loop
            muted={videoMuted}
            preload="none"
            src={previews.icon_with_video_preview.video_url}
            poster={previews.icon_with_video_preview.landscape_url}
          />
        </Magnifier>
      )
    }

    if (get(previews, 'icon_with_landscape_preview.landscape_url')) {
      return (
        <Magnifier item={item} width={477} height={240}>
          <img src={previews.icon_with_landscape_preview.landscape_url} />
        </Magnifier>
      )
    }

    return null
  }

  return <div className="fds-u-hide-small-and-below">{getMagnifier()}</div>
}

export default MagnifierConfigurator



// WEBPACK FOOTER //
// ./client/components/magnifier/configurator.tsx